import React from "react";
import GlobalFilter from "./GlobalFilter";

const TableSearch = ({ globalFilter, setGlobalFilter, table }) => {
  const search = table.options.meta?.fullTextSearch;

  return (
    <span className="lg:w-1/2">
      <GlobalFilter
        value={globalFilter ?? ""}
        // If we're using server-side search (fullTextSearch), don't double-debounce:
        // - GlobalFilter debounce: 0ms (immediate)
        // - useFetchAll/useDebounceSearch handles the debounce + min-length logic
        debounce={search ? 0 : 500}
        onChange={(value) =>
          search ? search(String(value)) : setGlobalFilter(String(value))
        }
      />
    </span>
  );
};

export default TableSearch;
